// Video card for the calendar sidebar "phone" preview (type 'V').
// Copy of the workouts module's VideoCard. The video stays PLAYABLE — it sits above the
// preview overlay (higher z-index) and opens the calendar's own videoModal.
import React from 'react';
import { useDispatch } from 'react-redux';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import IcomoonReact from 'icomoon-react';

import iconSet from '../../../../shared/images/teambuildr-selection.json';
import { BoxShadow } from '../../../../shared/GlobalStyles';
import { setActiveModal } from '../../ducks/calendarActions';

const Container = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: ${BoxShadow};
  border-radius: 12px;
  background: white;
  margin-top: 20px;
  height: 200px;
  cursor: pointer;
  /* Sit above the preview overlay so the video remains clickable. */
  position: relative;
  z-index: 11;
`;

const MediaContainer = styled('div')`
  background-image: ${(props) => `url(${props.background})`};
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ContentContainer = styled('div')`
  display: flex;
  padding: 10px;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const PlayButton = styled('div')`
  width: 33px;
  height: 33px;
  cursor: pointer;
  border-radius: 50%;
  border: 2px solid white;
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    margin-left: 2px;
    margin-top: 1px;
  }
`;

const CalendarVideoCard = ({ workoutObject }) => {
  const dispatch = useDispatch();
  const video = workoutObject?.video;

  const handlePlay = () => {
    if (video?.mediaUrl) {
      dispatch(setActiveModal('videoModal', { url: video.mediaUrl }));
    }
  };

  return (
    <Container onClick={handlePlay}>
      <ContentContainer>
        <MediaContainer background={video?.thumbnailUrl}>
          <PlayButton>
            <IcomoonReact iconSet={iconSet} size={15} icon='play-filled' color='white' />
          </PlayButton>
        </MediaContainer>
      </ContentContainer>
    </Container>
  );
};

CalendarVideoCard.propTypes = {
  workoutObject: PropTypes.instanceOf(Object).isRequired,
};

export default CalendarVideoCard;
